import { takeEvery, put, call, select } from 'redux-saga/effects'

import api from 'api'
import {
  loginUser,
  setIsAuth,
  getProfileUserDataIdSelector,
  setIsFetching,
  setUserData,
  setIsLoading,
  getSession,
  logout,
  restorePassword,
  setRestorePasswordEmailString,
  changePassword,
  setIsSuccessResporePassword,
  setErrorResporePasswordType,
  setNewPasswordRequiredData,
  clearNewPasswordRequiredData,
  getUserProfile,
  editProfile,
  changeCurrentPassword,
  getProfileDataSelector,
  setSuccessChangedData,
  clearError,
  setChangePasswordErrorCode,
  clearChangePasswordErrorCode,
  sendProfileAvatar,
  setProfileAvatar,
} from 'redux/reducers/profile'
import { showAlert } from 'redux/reducers/notification'
import { AWSService } from 'services/awsServices'

function* getSessionWorker() {
  try {
    const token = yield call(AWSService.getSession)
    if (token) {
      yield (api.token = token)
      yield call(getUserProfileSagaWorker)
    }
  } catch (error) {
    if (error?.message) {
      yield put(
        showAlert({
          severity: 'error',
          message: error?.message,
          alertTitle: 'Login Error',
        })
      )
    }
  } finally {
    yield put(setIsLoading(false))
  }
}

function* profileLoginSagaWorker({ payload }) {
  try {
    yield put(setIsFetching(true))

    const result = yield call(AWSService.login, payload)

    switch (result.type) {
      case 'success':
        api.token = result?.data
        yield call(getUserProfileSagaWorker)
        break
      case 'new_password_recovery':
        yield put(setNewPasswordRequiredData(result?.data))
        break
      default:
        break
    }
  } catch (error) {
    yield put(
      showAlert({
        severity: 'error',
        message: error?.message,
        alertTitle: 'Login Error',
      })
    )
  } finally {
    yield put(setIsFetching(false))
  }
}

function* logoutSagaWorker() {
  try {
    yield call(AWSService.logout)
  } catch (error) {
    yield put(
      showAlert({
        severity: 'error',
        message: error?.message,
        alertTitle: 'Login Error',
      })
    )
  }
}

function* restorePasswordWorker({ payload = '' }) {
  try {
    yield put(setIsFetching(true))

    const result = yield call(AWSService.restorePassword, payload)

    yield put(setRestorePasswordEmailString(result))
  } catch (error) {
    yield put(
      setErrorResporePasswordType({
        type: error?.code,
      })
    )
  } finally {
    yield put(setIsFetching(false))
  }
}

function* changePasswordWorker({ payload }) {
  try {
    yield put(setIsFetching(true))

    if (payload.code === 'new_password') {
      const result = yield call(AWSService.completeNewPassword, payload)
      api.token = result
      yield put(clearNewPasswordRequiredData())
      yield call(getUserProfileSagaWorker)
    } else {
      yield call(AWSService.changePassword, payload)
      yield put(setIsSuccessResporePassword(true))
    }
  } catch (error) {
    yield put(
      setErrorResporePasswordType({
        type: error?.code,
      })
    )
  } finally {
    yield put(setIsFetching(false))
  }
}

function* getUserProfileSagaWorker() {
  try {
    const { data } = yield call([api.profile, 'getProfile'])
    yield put(setUserData(data?.body))
    yield put(setIsAuth(true))
  } catch (error) {
    yield put(
      showAlert({
        severity: 'error',
        message: error?.message,
        alertTitle: 'Login Error',
      })
    )
  }
}

function* editProfileSagaWorker({ payload }) {
  try {
    yield put(setIsFetching(true))
    const userId = yield select(getProfileUserDataIdSelector)
    const res = yield call([api.profile, 'editProfile'], userId, payload)
    if (res.status === 200) {
      yield call(getUserProfileSagaWorker)
      yield put(clearError())
      yield put(setSuccessChangedData({ isShow: true }))
    }
  } catch (error) {
    // const message = handleError(error)
    // yield put(
    //   setError({
    //     code: error?.code,
    //     message: message,
    //   })
    // )
    yield put(
      showAlert({
        severity: 'error',
        message: error?.message,
        alertTitle: 'Login Error',
      })
    )
  } finally {
    yield put(setIsFetching(false))
  }
}

function* changeCurrentPasswordSagaWorker({ payload }) {
  const { callback, ...rest } = payload
  try {
    yield put(setIsFetching(true))
    const { email } = yield select(getProfileDataSelector)

    yield call(AWSService.changeCurrentPassword, {
      ...rest,
      userName: email,
    })
    yield put(clearChangePasswordErrorCode())
    yield put(setSuccessChangedData({ isShow: true }))
    callback()
  } catch (error) {
    yield put(setChangePasswordErrorCode(error?.code))
  } finally {
    yield put(setIsFetching(false))
  }
}

function* sendProfileAvatarSagaWorker({ payload }) {
  try {
    yield put(setIsFetching(true))
    const { file, params } = payload
    const { data } = yield call(
      [api.profile, 'sendProfileAvatar'],
      file,
      params
    )
    yield put(setProfileAvatar(data?.body))
  } catch (error) {
    // const message = handleError(error)
    // yield put(
    //   setError({
    //     code: error?.code,
    //     message: message,
    //   })
    // )
    yield put(
      showAlert({
        severity: 'error',
        message: error?.message,
        alertTitle: 'Login Error',
      })
    )
  } finally {
    yield put(setIsFetching(false))
  }
}

export default function* profileSagaWatcher() {
  yield takeEvery(loginUser.type, profileLoginSagaWorker)
  yield takeEvery(getSession.type, getSessionWorker)
  yield takeEvery(logout.type, logoutSagaWorker)
  yield takeEvery(restorePassword.type, restorePasswordWorker)
  yield takeEvery(changePassword.type, changePasswordWorker)
  yield takeEvery(getUserProfile.type, getUserProfileSagaWorker)
  yield takeEvery(editProfile.type, editProfileSagaWorker)
  yield takeEvery(changeCurrentPassword.type, changeCurrentPasswordSagaWorker)
  yield takeEvery(sendProfileAvatar.type, sendProfileAvatarSagaWorker)
}
